<template>
  <v-flex
    class="line-item"
    xs12>
    <v-expansion-panel>
      <v-expansion-panel-content
        v-for="(item, index) in items"
        :key="index"
        hide-actions>
        <template v-slot:header>
          <LineItem :item="item"/>
        </template>

        <LineItemNotes
          v-if="cart.hasNotes(item)"
          :notes="item.notes"
        />
        <div
          v-if="item.discounts.length"
          class="mx-3 mt-4"
        >
          <div class="font-weight-bold subheading ">
            {{ $t('Included Discounts') }}
          </div>

          <order-discount-breakdown :discounts="item.discounts" />

          <v-divider class="grey lighten-3" />

          <order-discount-total
            :total-discount="item.total_discount"
            class="mb-4"
          />
        </div>
      </v-expansion-panel-content>
    </v-expansion-panel>
  </v-flex>
</template>

<script>
import LineItem from './LineItem'
import LineItemNotes from './LineItemNotes'
import OrderDiscountExpandableHeader from '../OrderSingle/OrderSingleDiscount/OrderDiscountExpandableHeader'
import OrderDiscountBreakdown from '../OrderSingle/OrderSingleDiscount/OrderDiscountBreakdown'
import OrderDiscountTotal from '../OrderSingle/OrderSingleDiscount/OrderDiscountTotal'

export default {
  name: 'LineItems',

  components: {
    OrderDiscountTotal,
    LineItemNotes,
    LineItem,
    OrderDiscountExpandableHeader,
    OrderDiscountBreakdown
  },

  props: {
    items: {
      type: Array,
      required: true
    }
  },

  data () {
    return {
      cart: this.$http.make('cart')
    }
  }
}
</script>
